import { RangePickerFilter } from '@shared/components'
import { useQueryUpdate } from '@shared/hooks'
import { Input, Select, Space } from 'antd'
import dayjs from 'dayjs'
import { useTranslation } from 'react-i18next'

const { Search } = Input

const logTypes = ['create', 'update', 'delete']

export const LogApplicationsFilters = () => {
  const { t } = useTranslation()
  const { params, updateQuery } = useQueryUpdate()

  const onSearchModel = (model: string) => updateQuery({ model })

  const onChangeModel = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!e.target.value) {
      updateQuery({
        model: ''
      })
    }
  }

  return (
    <Space wrap>
      <Search
        defaultValue={params.model}
        onChange={onChangeModel}
        onSearch={onSearchModel}
        placeholder={t('table.model')}
        enterButton
        allowClear
      />

      <RangePickerFilter
        maxDate={dayjs()}
        fromParam="timestampGte"
        toParam="timestampLte"
      />

      <Select
        placeholder={t('table.type')}
        value={params.type}
        onChange={(type) => updateQuery({ type })}
        options={logTypes.map((value) => ({
          label: t(`log_type.${value}`),
          value
        }))}
        style={{ minWidth: 200 }}
        allowClear
      />
    </Space>
  )
}
